'use client';

import { motion } from 'framer-motion';
import { PortableText } from '@portabletext/react';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { PortableTextBlock } from 'sanity';
import ProfitSlider from '@/components/pageComponents/global/ProfitSlider';
import { cn } from '@/lib/utils';

const ease = [0.25, 0.1, 0.25, 1] as const;

interface IProfitSliderSectionData {
  sliderChip?: string;
  sliderTitle?: PortableTextBlock[];
}

export default function ProfitSliderSection({
  data,
  className,
}: {
  data: IProfitSliderSectionData;
  className?: string;
}) {
  if (!data?.sliderTitle) return null;

  return (
    <section
      className={cn(
        'relative w-full bg-white py-0  lg:py-[16rem] overflow-hidden',
        className,
      )}
    >
      <div className="mx-auto w-[min(170.5rem,calc(100%-4rem))] lg:w-[min(170.5rem,calc(100%-8rem))] flex flex-col items-center gap-[8rem]">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease }}
          className="flex flex-col items-center gap-[2rem] text-center"
        >
          {data?.sliderChip && (
            <p className="mb-0 font-blacker italic text-[2rem] text-black leading-[1.5]">
              {data.sliderChip}
            </p>
          )}
          <div className="richtext prose-headings:text-black prose-p:text-black/70 flex flex-col gap-[2rem] prose-p:text-[2rem] max-w-[78.25rem]">
            <PortableText
              value={data.sliderTitle}
              components={richTextComponent}
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.9, ease, delay: 0.1 }}
          className="w-full flex justify-center"
        >
          <ProfitSlider />
        </motion.div>
      </div>
    </section>
  );
}
